import store, { storeModules } from "../store";
import {
    TAB_VIEW_ACTIONS,
    
  } from '../store/tab-view/tab-view-types.store';
import { IdentifyTabData } from '../models/common/tab-view.model';

const tabViewStoreModule = `${storeModules.TabView}`;

export const storeUpdateTabviewTitle = (payload: { tab: {
    identifyData: IdentifyTabData
}, value: string }) => {
    store.dispatch(
        `${tabViewStoreModule}/${TAB_VIEW_ACTIONS.UPDATE_TAB_TITLE}`,
        payload
    )
}
export const getStoreTabViews = () => {
	return store.state[tabViewStoreModule].tabViews;
} 
export const verifyExistedUnsavedDataTab = () => {
    return false;
}